import { render, staticRenderFns } from "./AppDrawer.vue?vue&type=template&id=b88c6b8a&scoped=true"
import script from "./AppDrawer.ts?vue&type=script&lang=ts&external"
export * from "./AppDrawer.ts?vue&type=script&lang=ts&external"
import style0 from "./AppDrawer.scss?vue&type=style&index=0&id=b88c6b8a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88c6b8a",
  null
  
)

export default component.exports